import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Route → theme mapping.
// - Aurora: splash + every auth-style entry page (high-impact first impression)
// - Pastel: main browsing surfaces (long-session friendly)
// - None  : admin portal (keeps its existing dark theme)
const AURORA_ROUTES = [
  /^\/$/,                    // splash
  /^\/buyer\/login$/,
  /^\/seller\/login$/,
  /^\/admin\/login$/,
  /^\/role-select$/,
  /^\/forgot-password$/,
  /^\/preview\/backgrounds$/, // keep preview untouched
];

const NO_THEME_ROUTES = [
  /^\/admin($|\/)/,          // admin keeps dark
  /^\/live-classes\/[^/]+\/join$/, // Jitsi room is fullscreen, no chrome
];

const useThemeBackground = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const body = document.body;
    body.classList.remove('theme-aurora', 'theme-pastel');

    if (NO_THEME_ROUTES.some(rx => rx.test(pathname))) return;
    if (AURORA_ROUTES.some(rx => rx.test(pathname))) {
      body.classList.add('theme-aurora');
      return;
    }
    body.classList.add('theme-pastel');
  }, [pathname]);
};

export default useThemeBackground;
